// Modal cấu hình TỪ CẤM kiểm duyệt: comment/reply CHỨA từ cấm tự vào hàng chờ
// duyệt (không phân biệt hoa thường & dấu). Mỗi dòng 1 từ/cụm từ.
import React, { useEffect, useState } from "react";
import { Modal, Input, message, Alert } from "antd";
import postApi from "../../../../api/postApi";

export default function BannedWordsModal({ open, onClose }) {
    const [text, setText] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    // Mở modal -> tải danh sách hiện tại
    useEffect(() => {
        if (!open) return;
        (async () => {
            try {
                setLoading(true);
                const { data } = await postApi.getBannedWords();
                setText((data?.data?.words || []).join("\n"));
            } catch {
                message.error("Không thể tải danh sách từ cấm");
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    const handleSave = async () => {
        const words = text
            .split("\n")
            .map((w) => w.trim())
            .filter(Boolean);
        try {
            setSaving(true);
            await postApi.updateBannedWords(words);
            message.success(`Đã lưu ${words.length} từ cấm`);
            onClose();
        } catch {
            message.error("Không thể lưu từ cấm");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Từ cấm kiểm duyệt bình luận"
            open={open}
            onOk={handleSave}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Đóng"
            confirmLoading={saving}
        >
            <Alert
                type="info"
                showIcon
                className="mb-3"
                message="Bình luận CHỨA từ cấm sẽ tự vào mục Chờ duyệt (không hiển thị công khai cho tới khi được duyệt). So khớp không phân biệt hoa thường và dấu."
            />
            <Input.TextArea
                rows={12}
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder={"Mỗi dòng 1 từ/cụm từ, ví dụ:\nhttp\nzalo\nvay tiền"}
                disabled={loading}
            />
        </Modal>
    );
}
